import { InfoCircleOutlined } from '@ant-design/icons';
import { Popover, Space, Typography } from 'antd';
import { ReactNode } from 'react';

interface LabelWithToolTipProps {
    children: ReactNode;
    tooltip?: string;
}

const { Text } = Typography;

const LabelWithToolTip = ({ children, tooltip }: LabelWithToolTipProps): JSX.Element => (
    <Space>
        <strong style={{ fontSize: 13, display: 'block' }}>{children}</strong>
        {tooltip && (
            <Popover
                placement="bottomLeft"
                content={<Text type="secondary">{tooltip}</Text>}
                trigger="hover"
                overlayStyle={{ fontSize: 13, width: 300 }}
            >
                <InfoCircleOutlined style={{ fontSize: 13, color: 'GrayText' }} />
            </Popover>
        )}
    </Space>
);

export default LabelWithToolTip;
